import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { Box, Typography } from "@mui/material";
import { ExclamationRedIcon } from "../Icon/ExclamationRedIcon";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export function UIErrorDisplay(props: { validationBreaks: ValidationIssue[] | undefined }) {
    if (props.validationBreaks && props.validationBreaks.length !== 0) {
        let validation: ValidationIssue[] = [];

        for (let i of props.validationBreaks) {
            if (validation.find((ii) => i.issue === ii.issue)) {
                // its a dup
            } else {
                validation.push(i);
            }
        }

        return (
            <Box
                flexDirection="column"
                display="flex"
                justifyContent="flex-start"
                border={1}
                padding="7px"
                bgcolor={UIStyleConstants.RED_VERY_LIGHT_COLOR}
                width={"100%"}
                borderRadius="4px"
                borderColor={UIStyleConstants.RED_COLOR}
            >
                {validation.map((v) => {
                    return (
                        <Box
                            key={"validation_issue:" + v.issue}
                            flexDirection="row"
                            display="flex"
                            justifyContent="flex-start"
                            width="100%"
                            paddingRight="5px"
                            paddingLeft="5px"
                        >
                            <ExclamationRedIcon style={{ paddingRight: 5 }} />
                            <Typography>{v.issue}</Typography>
                        </Box>
                    );
                })}
            </Box>
        );
    } else {
        return null;
    }
}
